const styles = (theme) => ({
  borderColor: {
    '& .MuiFormLabel-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  skeleton: {
    transform: 'scale(1)',
  },
});

export default styles;
